import * as angular from "angular";
import {ITemplateCacheService} from "angular";
import "angular-utf8-base64";
import {ApplicationService} from "./application.service";
import {ChatModule} from "../chat/chat.module";
import {FacultyModule} from "../faculty/faculty.module";
import {PriorStudyModule} from "../prior-study/prior-study.module";
import {CourseModule} from "../course/course.module";
import {ApplicationCommentsButtonComponent} from "./comments-button/application-comments-button.component";
import {ApplicationCommentsComponent} from "./comments/application-comments.component";
import {ApplicationDeleteAttachmentModalComponent} from "./modals/delete-attachment-modal/application-delete-attachment-modal.component";
import {ApplicationOutcomeCommentComponent} from "./outcome-comment/application-outcome-comment.component";
import {ApplicationReallocateFacultyModalComponent} from "./modals/reallocate-faculty-modal/application-reallocate-faculty-modal.component";
import {ApplicationApproveModalComponent} from "./modals/approve-modal/application-approve-modal.component";
import {ArchiveApplicationModalComponent} from "./modals/archive-modal/application-archive-modal.component";
import {OfflineModalComponent} from "./modals/offline-modal/offline-modal.component";
import {ApplicationDeclineModalComponent} from "./modals/decline-modal/application-decline-modal.component";
import {ApplicationReopenModalComponent} from "./modals/reopen-modal/application-reopen-modal.component";
import {ApplicationReopenSummaryModalComponent} from "./modals/reopen-summary-modal/application-reopen-summary-modal.component";
import {ApplicationStatusComponent} from "./status/application-status.component";
import {ApplicationStepperComponent} from "./stepper/application-stepper.component";
import {AttachmentListComponent} from "./attachment-list/attachment-list.component";
import {CparModule} from "../cpar/cpar.module";
import {CourseOfferStatusComponent} from "./course-offer-status/course-offer-status.component";
import {ReleaseApplicationModalComponent} from "./modals/release-modal/release-modal.component";
import {DeleteDraftModalComponent} from "../../staff/application/draft-delete-modal/draft-delete-modal.component";
import {InfoModalComponent} from "./modals/info-modal/info-modal.component";
import {LogModule} from "../log/log.module"

export const ApplicationModule = angular
    .module("app.shared.application", [
        "utf8-base64",
        "ngAnimate",
        "ui.bootstrap",
        ChatModule,
        FacultyModule,
        PriorStudyModule,
        CourseModule,
        CparModule,
        LogModule
    ])

    .service("applicationService", ApplicationService)

    .component("applicationComments", ApplicationCommentsComponent)
    .component("applicationCommentsButton", ApplicationCommentsButtonComponent)
    .component("applicationOutcomeComment", ApplicationOutcomeCommentComponent)
    .component("applicationApproveModal", ApplicationApproveModalComponent)
    .component("applicationDeleteAttachmentModal", ApplicationDeleteAttachmentModalComponent)
    .component("applicationDeclineModal", ApplicationDeclineModalComponent)
    .component("applicationReallocateFacultyModal", ApplicationReallocateFacultyModalComponent)
    .component("applicationReopenModal", ApplicationReopenModalComponent)
    .component("applicationReopenSummaryModal", ApplicationReopenSummaryModalComponent)
    .component("applicationStatus", ApplicationStatusComponent)
    .component("archiveApplicationModal", ArchiveApplicationModalComponent)
    .component("deleteDraftModal", DeleteDraftModalComponent)
    .component("offlineModal", OfflineModalComponent)
    .component("releaseApplicationModal", ReleaseApplicationModalComponent)
    .component("infoModal", InfoModalComponent)
    .component("applicationStepper", ApplicationStepperComponent)
    .component("attachmentList", AttachmentListComponent)
    .component("courseOfferStatus", CourseOfferStatusComponent)

    .run(($templateCache: ITemplateCacheService) => {
        // manually load into template cache to make it available for use with ng-include
        $templateCache.put("application-form.html", require("./form/application-form.html"));
    })

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/application.module.ts